import { Component, input, output } from '@angular/core';
import { RoleInput } from '../../../api/types';
import {
  SynButtonComponent,
  SynCheckboxComponent,
  SynergyFormsModule,
  SynIconComponent,
  SynInputComponent, SynValidateComponent,
} from '@synergy-design-system/angular';
import { FormsModule, NgForm } from '@angular/forms';
import { HelpTextComponent } from '../../components/help-text.component';

@Component({
  selector: 'app-role-form',
  template: `
    <form #form=ngForm class="flex-col gap-2" style="width: 640px;" (submit)="onSubmit(form)">
      <app-help-text>
        <syn-validate on="invalid change">
          <syn-input
            label="Name" i18n-label="@@name"
            [(ngModel)]="this.role().name"
            [required]="true"
            [minlength]="3"
            [disabled]="!canEdit()"
            name="name"
            data-e2e="input-role-name" />
        </syn-validate>
        <span helpText i18n="@@role-name-help">
          The name of the role will be mapped into the token of the user's in that role.
        </span>
      </app-help-text>
      <app-help-text>
        <syn-input
          label="Description" i18n-label="@@description"
          [(ngModel)]="this.role().description"
          [spellcheck]="false"
          [maxlength]="100"
          [disabled]="!canEdit()"
          name="description"
          data-e2e="input-role-description" />
        <span helpText i18n="@@role-description-help">
          Document the purpose of this role.
        </span>
      </app-help-text>
      <app-help-text>
        <syn-checkbox [disabled]="!canEdit()" [(ngModel)]="this.role().isPublic" name="isPublic">
          <span i18n="@@public">Public</span>
        </syn-checkbox>
        <span helpText i18n="@@role-public-help">
          A public role can be mapped into tokens of other clients.
          If this role is only intended to be used by your client, leave this option disabled.
        </span>
      </app-help-text>

      <syn-button
        variant="filled"
        type="submit"
        [disabled]="!form.dirty || !!form.invalid || !canEdit()"
        data-e2e="btn-submit-role"
      >
        <syn-icon [name]="submitIcon() + '_fill'" slot="prefix" />
        <span>{{ submitText() }}</span>
      </syn-button>
    </form>
  `,
  styles: [],
  imports: [
    SynButtonComponent,
    SynIconComponent,
    SynInputComponent,
    SynCheckboxComponent,
    SynergyFormsModule,
    FormsModule,
    SynValidateComponent,
    HelpTextComponent,
  ],
})
export class RoleFormComponent {
  role = input.required<RoleInput>();

  canEdit = input.required<boolean>();

  submitIcon = input('');
  submitText = input('');
  submitRole = output<RoleInput>();

  onSubmit(form: NgForm) {
    if (form.invalid) return;

    this.submitRole.emit(form.value as RoleInput);
    form.form.markAsPristine();
  }
}
